<template>
  <v-app id="app_overall_tracking_history">
    <v-overlay v-model="loadningScreen" :scrim="false" class="centered-overlay">
      <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <!-- Header -->
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">OVERALL HISTORY</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Analyse the collection of overall history tracking data based on agents.
          </p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <!-- Filters + table -->
      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <template v-slot:append>
          <v-card-text class="custom_tool_bar_style">
            <v-btn class="custom_pdf_btn" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
            <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-card-text>
        </template>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="4">
              <v-date-input
                  v-model="dates"
                  append-inner-icon="mdi-close"
                  prepend-inner-icon="$calendar"
                  prepend-icon=""
                  label="Select Date Range"
                  multiple="range"
                  variant="outlined"
                  @click:append-inner="clearDateRange"
                  density="comfortable"
                  class="custom_input_field_color"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                  v-model="agentList"
                  :items="agentDataOptions"
                  item-title="displayName"
                  item-value="id"
                  label="Sales Rep Name"
                  placeholder="Select Sales Rep name"
                  variant="outlined"
                  density="comfortable"
                  class="custom_input_field_color"
                  multiple
                  clearable
                  :loading="salesRepLoading"
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props">
                    <v-list-item-title>
                      <span v-if="item.raw?.code" class="sales-rep-code-text">{{ item.raw.code }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </template>
<!--                <template v-slot:chip="{ props, item }">-->
<!--                  <v-chip-->
<!--                    v-bind="props"-->
<!--                    color="#e7e7e7"-->
<!--                    variant="flat"-->
<!--                    class="text-black font-weight-medium"-->
<!--                    size="small"-->
<!--                    closable-->
<!--                  >-->
<!--                    <span class="sales-rep-name-text">{{ item.raw?.name || item.title }}</span>-->
<!--                    <span v-if="item.raw?.code" class="sales-rep-code-text">{{ item.raw.code }}</span>-->
<!--                  </v-chip>-->
<!--                </template>-->
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                  v-model="serachModel"
                  label="Search"
                  persistent-placeholder
                  placeholder="Search"
                  variant="outlined"
                  density="comfortable"
                  class="custom_input_field_color"
              />
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-data-table
              :headers="headers"
              :items="filteredData"
              :loading="loading"
              :search="serachModel"
              class="custom_table_normal"
          >
            <template v-slot:[`item.trackingId`]="{ item }">
              <p class="text-caption custom_page_main_sub_title font-weight-bold mt-2">{{ item.trackingId }}</p>
            </template>

            <template v-slot:[`item.agentName`]="{ item }">
              <p class="text-caption custom_page_main_sub_title font-weight-bold mt-2">{{ item.agentName }}</p>
            </template>

            <template v-slot:[`item.totalDistance`]="{ item }">
              <p class="text-caption font-weight-bold mt-2">
                <span style="color: black;">{{ item.totalDistance }}</span> <span style="color: blue;">KM</span>
              </p>
            </template>

            <template v-slot:[`item.date`]="{ item }">
              <p class="text-caption custom_page_main_sub_title font-weight-bold mt-2">{{ item.date }}</p>
            </template>

            <template v-slot:[`item.dayIn`]="{ item }">
              <p class="text-caption font-weight-bold mt-2">
                <template v-if="item.dayIn && item.dayIn.includes(' ')">
                  <span style="color: blue;">{{ item.dayIn.split(' ').slice(1).join(' ') }}</span>
                </template>
                <template v-else>
                  <span style="color: blue;">{{ item.dayIn || '-' }}</span>
                </template>
              </p>
            </template>

            <template v-slot:[`item.dayOut`]="{ item }">
              <p class="text-caption font-weight-bold mt-2">
                <template v-if="item.dayOut && item.dayOut.includes(' ')">
                  <span style="color: blue;">{{ item.dayOut.split(' ').slice(1).join(' ') }}</span>
                </template>
                <template v-else>
                  <span style="color: blue;">{{ item.dayOut || '-' }}</span>
                </template>
              </p>
            </template>

            <template v-slot:[`item.workingTime`]="{ item }">
              <p class="text-caption custom_page_main_sub_title font-weight-bold mt-2">{{ formatWorkingTimeAsDecimal(item.workingTime) }}</p>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_user_role_list">
                <template v-slot:activator="{ props }">
                  <v-btn 
                    variant="flat" 
                    size="large" 
                    v-bind="props" 
                    style="background-color: #800080 !important; color: #ffffff !important;"
                  >
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="permissions.read" @click="mapView(item)">
                    <v-list-item-title class="custom_page_color_view">MAP VIEW</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                    <v-list-item-title class="custom_page_color_delete">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination v-model="page" :length="totalPages" :total-visible="10" />
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- MAP VIEW Dialog -->
      <v-dialog v-model="mapViewDialog" fullscreen id="app_overall_tracking_history">
        <v-card flat>
          <v-toolbar class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense style="border-radius: 0 !important;">
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="closeD()" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn 
                variant="flat" 
                style="background-color: #800080 !important; color: #ffffff !important;" 
                @click="closeD()"
              >
                CLOSE
              </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12">
              <!-- Title card -->
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">MAP VIEW</v-card-title>
                </template>
              </v-card>

              <!-- CONTENT -->
              <v-card ref="mapElement" class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1">
                <!-- Header row: agent + download -->
                <v-row class="ma-0">
                  <v-col cols="12" sm="9">
                    <v-row>
                      <v-col cols="12" sm="3" md="2">
                        <v-img
                            :src="agentImage ? `${baseUrl}/${agentImage}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')"
                            max-width="150"
                            class="avatar-image"
                        />
                      </v-col>
                      <v-col cols="12" sm="9" md="6">
                        <v-table density="compact" class="custom_table_normal">
                          <tbody>
                          <tr>
                            <td><p class="font-weight-bold custom_page_component_main_title text-body-2">Sales Rep Name</p></td>
                            <td><p class="font-weight-bold custom_page_component_main_title text-body-2 custom_page_main_sub_title_very_small_red">{{ agentName }}</p></td>
                          </tr>
                          <tr>
                            <td><p class="font-weight-bold custom_page_component_main_title text-caption">Visited Date</p></td>
                            <td><p class="font-weight-medium text-caption custom_page_component_main_title mt-1">{{ visitedDate }}</p></td>
                          </tr>
                          <tr>
                            <td><p class="font-weight-bold custom_page_component_main_title text-caption">Total Distance</p></td>
                            <td><p class="font-weight-medium text-caption custom_page_component_main_title mt-1">{{ displayDistanceKm }}</p></td>
                          </tr>
                          <tr>
                            <td><p class="font-weight-bold custom_page_component_main_title text-caption">Start time</p></td>
                            <td><p class="font-weight-medium text-caption custom_page_component_main_title mt-1">{{ formatTimeOnly(startTime) }}</p></td>
                          </tr>
                          <tr>
                            <td><p class="font-weight-bold custom_page_component_main_title text-caption">End time</p></td>
                            <td><p class="font-weight-medium text-caption custom_page_component_main_title mt-1">{{ formatTimeOnly(endTime) }}</p></td>
                          </tr>
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" sm="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                        <v-btn 
                          v-if="showDownloadButton" 
                          variant="flat" 
                          size="large" 
                          style="background-color: #800080 !important; color: #ffffff !important;" 
                          @click="downloadPdf"
                        >
                          Download PDF
                        </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <!-- Summary cards row -->
                <v-row class="px-3 py-4">
                  <v-col cols="12" sm="6" md="3">
                    <v-card class="summary-card purple" elevation="0" rounded="lg">
                      <v-card-text class="d-flex align-center justify-space-between">
                        <div>
                          <div class="summary-title">Total Distance</div>
                          <div class="summary-value">{{ displayDistanceKm }}</div>
                        </div>
                        <div class="summary-icon">
                          <v-icon size="22">mdi-map-marker-distance</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-card class="summary-card blue" elevation="0" rounded="lg">
                      <v-card-text class="d-flex align-center justify-space-between">
                        <div>
                          <div class="summary-title">Duration</div>
                          <div class="summary-value">{{ displayDuration }}</div>
                        </div>
                        <div class="summary-icon">
                          <v-icon size="22">mdi-clock-outline</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-card class="summary-card green" elevation="0" rounded="lg">
                      <v-card-text class="d-flex align-center justify-space-between">
                        <div>
                          <div class="summary-title">Avg Speed</div>
                          <div class="summary-value">{{ avgSpeedKmh }} km/h</div>
                        </div>
                        <div class="summary-icon">
                          <v-icon size="22">mdi-speedometer</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-card class="summary-card amber" elevation="0" rounded="lg">
                      <v-card-text class="d-flex align-center justify-space-between">
                        <div>
                          <div class="summary-title">Waiting Time</div>
                          <div class="summary-value">{{ averageWaitingTime }}</div>
                        </div>
                        <div class="summary-icon">
                          <v-icon size="22">mdi-clock</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- TOP: Map snapshot and Receipts -->
                <v-row class="px-3 mt-1">
                  <v-col cols="12" md="8">
                    <div class="history-top-title d-flex justify-space-between align-center mb-2">
                      <p class="custom_page_component_main_title text-subtitle-1 font-weight-bold text-uppercase mb-0">
                        Journey Map
                      </p>
                      <v-switch
                        v-model="showRoutePaths"
                        color="#800080"
                        hide-details
                        density="compact"
                        class="mt-0 pt-0 ml-4"
                      >
                        <template v-slot:label>
                          <span class="text-caption font-weight-bold" style="color: #800080;">Show Routes</span>
                          <v-tooltip location="bottom" max-width="250">
                            <template v-slot:activator="{ props }">
                              <v-icon v-bind="props" size="small" class="ml-2" color="grey">mdi-information</v-icon>
                            </template>
                            <span>Enable this to view all associated dealers and their specific road-snapped paths for this journey.</span>
                          </v-tooltip>
                        </template>
                      </v-switch>
                    </div>

                    <div
                        ref="mapSnapshotArea"
                        class="rounded-lg custom_card_box d-flex overall_tracking_map"
                        style="position: relative; width: 100%; height: 420px;"
                    >
                      <div
                          v-if="isSnapshotLoading"
                          style="position:absolute; inset:0; display:flex; align-items:center; justify-content:center; background:rgba(255,255,255,0.55); z-index:5;"
                      >
                        <v-progress-circular color="green" indeterminate size="40"></v-progress-circular>
                      </div>

                      <img
                          v-if="historySnapshotUrl"
                          :src="historySnapshotUrl"
                          alt="Tracking history snapshot"
                          style="width: 100%; height: 100%; object-fit: cover; border-radius: 12px;"
                          @load="onSnapshotLoaded"
                          @error="onSnapshotError"
                      />

                      <GMapMap
                          v-else
                          :key="mapRenderKey"
                          :center="mapCenter"
                          :zoom="10"
                          class="history-gmap"
                          @idle="onMapIdle"
                      >
                        <GMapPolyline :options="polylineOptions" :path="pathCoordinates" />
                        <GMapMarker v-if="startPoint" :icon="startIcon" :position="startPoint" :title="'Start Point'" />
                        <GMapMarker v-if="endPoint" :icon="endIcon" :position="endPoint" :title="'End Point'" />
                        
                        <GMapMarker
                            v-for="(receipt, idx) in validReceipts"
                            :key="'receipt-'+idx"
                            :position="{ lat: parseFloat(receipt.latitude), lng: parseFloat(receipt.longitude) }"
                            :icon="{ url: 'https://maps.google.com/mapfiles/kml/pal2/icon13.png' }"
                            @click="selectReceipt(receipt)"
                        />

                        <GMapInfoWindow
                            v-if="selectedReceipt"
                            :key="'info-' + infoWindowKey"
                            :position="{ lat: parseFloat(selectedReceipt.latitude), lng: parseFloat(selectedReceipt.longitude) }"
                            :opened="true"
                            :options="{ pixelOffset: { width: 0, height: -10 } }"
                            @closeclick="selectedReceipt = null"
                        >
                          <div style="color: black; min-width: 280px; padding: 12px; font-family: 'Inter', 'Roboto', sans-serif;">
                            <div style="font-weight: 800; font-size: 16px; color: #111; border-bottom: 2px solid #e0e0e0; padding-bottom: 8px; margin-bottom: 12px; line-height: 1.2;">
                              {{ selectedReceipt.dealer_name }}
                            </div>
                            <div style="display: flex; flex-direction: column; gap: 6px; font-size: 13px;">
                              <div style="display: flex; justify-content: space-between;">
                                <span style="color: #666; font-weight: 600;">Dealer Code:</span>
                                <span style="font-weight: 500; color: #333;">{{ selectedReceipt.dealer_code || 'N/A' }}</span>
                              </div>
                              <div style="display: flex; justify-content: space-between;">
                                <span style="color: #666; font-weight: 600;">Receipt ID:</span>
                                <span style="font-weight: 500; color: #333;">{{ selectedReceipt.receipt_id || 'N/A' }}</span>
                              </div>
                              <div style="display: flex; justify-content: space-between;">
                                <span style="color: #666; font-weight: 600;">Date &amp; Time:</span>
                                <span style="font-weight: 500; color: #333;">{{ formatReceiptDate(selectedReceipt.created_at) }}</span>
                              </div>
                              <div style="display: flex; justify-content: space-between;">
                                <span style="color: #666; font-weight: 600;">Amount:</span>
                                <span style="color: #2e7d32; font-weight: 800;">LKR {{ selectedReceipt.collect_total_amount || '0' }}</span>
                              </div>
                              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 2px;">
                                <span style="color: #666; font-weight: 600;">Status:</span>
                                <span :style="{ backgroundColor: selectedReceipt.payment_status === 'OVERDUE' ? '#ffebee' : '#e8f5e9', color: selectedReceipt.payment_status === 'OVERDUE' ? '#d32f2f' : '#2e7d32', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold', textTransform: 'uppercase' }">
                                  {{ selectedReceipt.payment_status || 'N/A' }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </GMapInfoWindow>
                        <template v-if="showRoutePaths">
                          <template v-for="(group, gIndex) in dealerRouteGroups">
                            <GMapPolyline
                              v-for="(segment, sIndex) in group.segments"
                              :key="'dealer-path-' + group.routeId + '-' + gIndex + '-' + sIndex"
                              :path="segment"
                              :options="{ strokeColor: group.color, strokeOpacity: 1.0, strokeWeight: 4 }"
                            />
                          </template>

                          <GMapMarker
                              v-for="dealer in validRouteDealers"
                              :key="'dealer-' + dealer.id"
                              :position="{ lat: Number(dealer.latitude), lng: Number(dealer.longitude) }"
                              :icon="{ url: require('@/assets/ICONS/maker.png'), scaledSize: { width: 32, height: 32 } }"
                              @click="selectDealer(dealer)"
                          />

                          <GMapCircle
                              v-for="dealer in validRouteDealers"
                              :key="'dealer-circle-' + dealer.id"
                              :center="{ lat: Number(dealer.latitude), lng: Number(dealer.longitude) }"
                              :radius="5"
                              :options="{
                                strokeColor: '#800080',
                                strokeOpacity: 0.6,
                                strokeWeight: 1.5,
                                fillColor: '#800080',
                                fillOpacity: 0.25
                              }"
                          />
                        </template>

                        <GMapInfoWindow
                            v-if="selectedDealer"
                            :key="'dealer-info-' + selectedDealerKey"
                            :position="{ lat: Number(selectedDealer.latitude), lng: Number(selectedDealer.longitude) }"
                            :opened="true"
                            :options="{ pixelOffset: { width: 0, height: -30 } }"
                            @closeclick="closeDealerCard"
                        >
                          <v-card class="custom_card_box" elevation="0" rounded="lg" style="width: 280px; border:none!important;">
                            <v-card-text class="pa-2">
                              <div class="font-weight-bold text-subtitle-2">{{ selectedDealer.dealer_name }}</div>
                              <div class="text-caption" style="opacity:0.7;">Code: {{ selectedDealer.dealer_code }}</div>
                              <v-divider class="my-2"></v-divider>
                              <div class="d-flex align-center mb-1">
                                <v-icon size="16" color="green" class="mr-2">mdi-map-marker</v-icon>
                                <div class="font-weight-medium text-caption">{{ selectedDealer.address }}</div>
                              </div>
                              <div class="d-flex align-center mb-1">
                                <v-icon size="16" color="primary" class="mr-2">mdi-cash</v-icon>
                                <div class="font-weight-medium text-caption">Outstanding: {{ selectedDealer.total_outstanding }}</div>
                              </div>
                              <v-divider class="my-2"></v-divider>
                              <div class="d-flex align-center">
                                <v-spacer></v-spacer>
                                <v-chip size="x-small" variant="outlined" class="font-weight-bold" :color="selectedDealer.status === 'NOT VISITED' ? 'red' : 'green'">
                                  {{ selectedDealer.status }}
                                </v-chip>
                              </div>
                            </v-card-text>
                          </v-card>
                        </GMapInfoWindow>
                      </GMapMap>
                    </div>
                  </v-col>

                  <!-- Receipts Sidebar -->
                  <v-col cols="12" md="4">
                    <div class="history-top-title">
                      <p class="custom_page_component_main_title text-subtitle-1 font-weight-bold text-uppercase mb-2">
                        Receipts / Dealer Visits
                      </p>
                    </div>
                    <v-card class="rounded-lg custom_card_box overflow-y-auto" style="height: 420px; background-color: #f9f9f9;" flat>
                      <v-card-text class="pa-2">
                        <div v-if="receipts.length === 0" class="text-center mt-5" style="opacity: 0.6">
                          No receipts found for this journey.
                        </div>
                        <v-timeline v-else density="compact" side="end" align="start">
                          <v-timeline-item
                            v-for="(receipt, index) in receipts"
                            :key="index"
                            dot-color="#800080"
                            size="small"
                          >
                            <v-card class="mb-1 pa-3 mr-4" style="width: auto;" border="sm opacity-1" rounded="lg" elevation="0">
                              <p class="font-weight-bold text-subtitle-2 mb-1" style="color: #800080">{{ receipt.dealer_name }}</p>
                              <v-row dense>
                                <v-col cols="6">
                                  <p class="text-caption font-weight-medium" style="opacity: 0.7">Receipt ID:</p>
                                  <p class="text-caption font-weight-bold">{{ receipt.receipt_id || 'N/A' }}</p>
                                </v-col>
                                <v-col cols="6">
                                  <p class="text-caption font-weight-medium" style="opacity: 0.7">Waiting Time:</p>
                                  <p class="text-caption font-weight-bold">{{ receipt.waiting_time || '-' }}</p>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-timeline-item>
                        </v-timeline>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Time Distribution -->
                <v-row class="px-3 mt-4 mb-2">
                  <v-col cols="12">
                    <v-card class="custom_card_box" elevation="0" border="sm opacity-1" rounded="lg">
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <p class="text-subtitle-1 font-weight-bold mb-1">Time Distribution</p>
                            <p class="text-caption mb-3" style="opacity:.7;">
                              Driving / Waiting.
                            </p>

                            <div v-if="timeDist.totalSec === 0" class="text-caption" style="opacity:.7;">
                              No time distribution (timestamps missing).
                            </div>
                            <div v-else ref="timeDonutDiv" style="width: 100%; height: 220px;"></div>
                          </v-col>

                          <v-col cols="12" md="8">
                            <div class="dist-row">
                              <div class="dist-label">Driving</div>
                              <div class="dist-bar">
                                <div class="fill driving" :style="{ width: timeDistPercent.driving + '%' }"></div>
                              </div>
                              <div class="dist-pct">{{ timeDistPercent.driving }}%</div>
                            </div>

                            <div class="dist-row">
                              <div class="dist-label">Waiting</div>
                              <div class="dist-bar">
                                <div class="fill waiting" :style="{ width: timeDistPercent.waiting + '%' }"></div>
                              </div>
                              <div class="dist-pct">{{ timeDistPercent.waiting }}%</div>
                            </div>

                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Delete Dialog -->
      <v-dialog v-model="deleteDialog" id="app_overall_tracking_history" max-height="500" max-width="500" persistent>
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE TRACKING DATA</v-card-title>
              </template>
              <template v-slot:append>
                <v-btn @click="deleteDialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this tracking record ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This overall tracking record will be deleted immediately. Once deleted, it can no longer be used for any purpose.
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn class="custom_btn_primary" @click="deleteItem">DELETE</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="deleteDialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar
          v-model="snackAlert.snackbar"
          :color="snackAlert.snackColor"
          location="top right"
          timeout="3000"
      >
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import index from "vuex";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { getPermissions } from "@/plugins/permissions";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

export default {
  data() {
    return {
      receipts: [],
      selectedReceipt: null,
      infoWindowKey: 0,
      historySnapshotUrl: null,
      isSnapshotLoading: false,
      totalPointsOverride: 0,

      page: 1,
      totalPages: 0,
      loading: false,
      loadningScreen: false,
      deleteDialog: false,
      mapViewDialog: false,
      showDownloadButton: true,
      salesRepLoading: false,

      dates: [],
      serachModel: "",
      agentList: [],
      agentDataOptions: [],

      headers: [
        { text: "TRACKING ID", value: "trackingId", title: "TRACKING ID" },
        { text: "SALES REP NAME", value: "agentName", title: "SALES REP NAME" },
        { text: "DATE", value: "date", title: "DATE" },
        { text: "DAY IN", value: "dayIn", title: "DAY IN" },
        { text: "DAY OUT", value: "dayOut", title: "DAY OUT" },
        { text: "TOTAL DISTANCE", value: "totalDistance", title: "TOTAL DISTANCE" },
        { text: "WORKING HOURS", value: "workingTime", title: "WORKING HOURS" },
        { text: "Action", value: "actions", sortable: false, title: "ACTION" },
      ],
      trackingData: [],

      startLocation: "",
      endLocation: "",
      agentName: "",
      visitedDate: "",
      startTime: "",
      endTime: "",
      agentImage: "",
      baseUrl: "",
      totalDistanceOverride: null,
      workingTimeOverride: "",
      averageSpeedOverride: null,
      averageWaitingTime: "0 min",
      deleteTrackingId: "",

      mapCenter: { lat: 7.375783804167988, lng: 80.63752981355924 },
      pathCoordinates: [],
      polylineOptions: {
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 3,
      },
      startPoint: null,
      endPoint: null,
      startIcon: { url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png" },
      endIcon: { url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png" },

      timeDist: { drivingSec: 0, waitingSec: 0, totalSec: 0 },

      permissions: {},

      deleteAgentId: "",
      deleteDate: "",

      timeDonutChartInstance: null,

      mapRenderKey: 0,
      mapReady: false,
      routeDealers: [],
      dealerRouteGroups: [],
      selectedDealer: null,
      selectedDealerKey: 0,
      staticMapSize: "900x420",

      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarTop: true,
      },

      showRoutePaths: false,
    };
  },

  watch: {
    page(newVal) {
      this.getAllTracking(newVal);
    },
    dates() {
      this.page = 1;
      this.getAllTracking(this.page);
    },
    serachModel() {
      this.page = 1;
      this.getAllTracking(this.page);
    },
    agentList() {
      this.page = 1;
      this.getAllTracking(this.page);
    },
    mapViewDialog(open) {
      if (!open) this.disposeCharts();
    },
  },

  computed: {
    validReceipts() {
      return this.receipts.filter((r) => r.latitude && r.longitude && !isNaN(parseFloat(r.latitude)) && !isNaN(parseFloat(r.longitude)));
    },

    validRouteDealers() {
      return this.routeDealers.filter(
        (d) =>
          d &&
          d.latitude !== undefined &&
          d.latitude !== null &&
          d.latitude !== "" &&
          d.longitude !== undefined &&
          d.longitude !== null &&
          d.longitude !== "" &&
          !isNaN(parseFloat(d.latitude)) &&
          !isNaN(parseFloat(d.longitude))
      );
    },

    index() {
      return index;
    },

    displayDistanceKm() {
      if (this.totalDistanceOverride !== null && this.totalDistanceOverride !== undefined) {
        const km = Number(this.totalDistanceOverride || 0);
        return `${km.toFixed(1)} km`;
      }
      return "0.0 km";
    },

    timeDistPercent() {
      const total = this.timeDist.totalSec || 0;
      if (!total) return { driving: 0, waiting: 0 };

      const toPct = (x) => Math.round((x / total) * 100);
      let driving = toPct(this.timeDist.drivingSec);
      let waiting = 100 - driving;
      if (this.timeDist.waitingSec > 0) waiting = toPct(this.timeDist.waitingSec);
      if (waiting < 0) waiting = 0;
      if (driving + waiting !== 100) waiting = Math.max(0, 100 - driving);
      return { driving, waiting };
    },

    filteredData() {
      let filtered = this.trackingData;

      if (this.serachModel && this.serachModel.trim() !== "") {
        filtered = filtered.filter(
            (item) =>
                (item.agentName || "").toLowerCase().includes(this.serachModel.toLowerCase()) ||
                (item.RegisterNumber || "").toLowerCase().includes(this.serachModel.toLowerCase()) ||
                (item.date || "").toLowerCase().includes(this.serachModel.toLowerCase()) ||
                (item.dayIn || "").toLowerCase().includes(this.serachModel.toLowerCase()) ||
                (item.dayOut || "").toLowerCase().includes(this.serachModel.toLowerCase()) ||
                (item.trackingId || "").toLowerCase().includes(this.serachModel.toLowerCase()) ||
                (item.workingTime || "").toLowerCase().includes(this.serachModel.toLowerCase())
        );
      }

      if (Array.isArray(this.agentList) && this.agentList.length > 0) {
        filtered = filtered.filter((item) => this.agentList.some(id => String(id) === String(item.agentId)));
      }

      const formatDate = (date) => {
        const d = new Date(date);
        return d.toISOString().split("T")[0];
      };

      const startDate = this.dates && this.dates.length > 0 ? formatDate(this.dates[0]) : null;
      const endDate = this.dates && this.dates.length > 0 ? formatDate(this.dates[this.dates.length - 1]) : null;

      if (startDate && endDate) {
        filtered = filtered.filter((item) => item.date >= startDate && item.date <= endDate);
      }

      return filtered;
    },

    displayDuration() {
      if (this.workingTimeOverride) return this.formatWorkingTime(this.workingTimeOverride);
      return "0 min";
    },

    avgSpeedKmh() {
      const speed = this.averageSpeedOverride;
      if (speed === null || speed === undefined || speed === "") return 0;
      const numericSpeed = Number(speed);
      if (!isFinite(numericSpeed)) return 0;
      return Number(numericSpeed.toFixed(0));


    },

    checkpointsCount() {
      const totalPoints = Number(this.totalPointsOverride || 0);
      if (!isFinite(totalPoints) || totalPoints <= 0) return 0;
      return totalPoints;
    },
  },

  mounted() {
    const dashboardId = 7;
    this.permissions = getPermissions(dashboardId);
    this.getAllTracking(this.page);
    this.fetchSalesReps();
    this.getBaseUrl();
  },

  beforeUnmount() {
    this.disposeCharts();
  },

  methods: {
    backPageRoute() {
      this.$router.push("/dashboard");
    },

    getBaseUrl() {
      this.baseUrl = `${process.env.VUE_APP_IMAGE_PUBLIC_URL}`;
    },

    clearDateRange() {
      this.dates = [];
    },

    resetHistorySnapshot() {
      this.historySnapshotUrl = null;
      this.isSnapshotLoading = false;
      this.selectedReceipt = null;
      this.receipts = [];
    },

    onSnapshotLoaded() {
      this.isSnapshotLoading = false;
    },

    onSnapshotError() {
      this.isSnapshotLoading = false;
      this.historySnapshotUrl = null;
    },

    onMapIdle() {
      this.mapReady = true;
      // FIX: Ensure loading is turned off when map is idle (fallback mode)
      this.isSnapshotLoading = false;
    },

    buildStaticMapUrl(points) {
      const apiKey = process.env.VUE_APP_GOOGLE_MAPS_KEY;
      if (!apiKey) return null;

      const clean = (points || [])
          .filter((p) => isFinite(p.lat) && isFinite(p.lng))
          .map((p) => `${p.lat},${p.lng}`);

      if (clean.length === 0) return null;

      const maxPts = 80;
      const step = Math.max(1, Math.floor(clean.length / maxPts));
      const sampled = clean.filter((_, i) => i % step === 0);

      const path = sampled.join("|");
      const start = sampled[0];
      const end = sampled[sampled.length - 1];

      return `https://maps.googleapis.com/maps/api/staticmap?size=${this.staticMapSize}&path=color:0xff0000ff|weight:3|${path}&markers=color:green|label:S|${start}&markers=color:red|label:E|${end}&key=${apiKey}`;
    },

    closeD() {
      this.disposeCharts();
      this.resetHistorySnapshot();
      this.mapViewDialog = false;
    },

    selectReceipt(receipt) {
      this.selectedReceipt = receipt;
      this.infoWindowKey += 1;
    },

    formatReceiptDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      
      const pad = (n) => n.toString().padStart(2, '0');
      const yyyy = d.getFullYear();
      const mm = pad(d.getMonth() + 1);
      const dd = pad(d.getDate());
      
      let hours = d.getHours();
      const minutes = pad(d.getMinutes());
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; 
      
      return `${yyyy}-${mm}-${dd} ${pad(hours)}:${minutes} ${ampm}`;
    },

    formatTimeOnly(dateStr) {
      if (!dateStr || dateStr === 'N/A' || dateStr === '-') return dateStr;
      
      // If it's already just a time string, return it
      if (typeof dateStr === 'string' && !dateStr.includes('-') && !dateStr.includes('/')) {
        return dateStr;
      }

      const d = new Date(dateStr);
      if (isNaN(d.getTime())) {
        if (typeof dateStr === 'string' && dateStr.includes(' ')) {
           const parts = dateStr.split(' ');
           return parts.slice(1).join(' ');
        }
        return dateStr;
      }
      
      const pad = (n) => n.toString().padStart(2, '0');
      let hours = d.getHours();
      const minutes = pad(d.getMinutes());
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; 
      
      return `${pad(hours)}:${minutes} ${ampm}`;
    },

    getSelectedDateRange() {
      if (!Array.isArray(this.dates) || this.dates.length === 0) return null;

      const formatDate = (date) => {
        if (!date) return null;
        if (typeof date === 'string') {
          const trimmed = date.trim();
          const dateOnlyMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
          if (dateOnlyMatch) return `${dateOnlyMatch[1]}-${dateOnlyMatch[2]}-${dateOnlyMatch[3]}`;
          const isoDateMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})T/);
          if (isoDateMatch) return `${isoDateMatch[1]}-${isoDateMatch[2]}-${isoDateMatch[3]}`;
        }
        const parsed = date instanceof Date ? date : new Date(date);
        if (Number.isNaN(parsed.getTime())) return null;
        const year = parsed.getFullYear();
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const day = String(parsed.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const selectedValues = this.dates
        .filter(Boolean)
        .map((date) => formatDate(date))
        .filter(Boolean)
        .sort();

      if (selectedValues.length === 0) return null;

      return {
        start: selectedValues[0],
        end: selectedValues[selectedValues.length - 1]
      };
    },

    async getAllTracking(page) {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      const size = 20;
      const currentPage = Number(page) > 0 ? Number(page) : 1;

      this.loading = true;

      try {
        const selectedDateRange = this.getSelectedDateRange();
        const params = {
          userId: userId ? parseInt(userId) : 1,
          size: size,
          page: currentPage
        };

        if (selectedDateRange) {
          params.fromDate = selectedDateRange.start;
          params.toDate = selectedDateRange.end;
        }

        if (this.serachModel && this.serachModel.trim() !== "") {
          params.searchQuery = this.serachModel.trim();
        }

        if (Array.isArray(this.agentList) && this.agentList.length > 0) {
          params.agentId = this.agentList.join(',');
        }

        const response = await axios.get(
            `api/tracking/v1/list`,
            {
              params: params,
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
        ).then((response) => {
            return response;
        });

        const payload = response.data || {};
        const rows = Array.isArray(payload.data) ? payload.data : [];

        this.trackingData = rows.map((r) => this.mapTrackingRow(r));

        if (payload.pagination) {
          this.totalPages = Number(payload.pagination.last_page || 1);
          this.page = Number(payload.pagination.current_page || 1);
        }
      } catch (error) {
        console.error("Error fetching tracking:", error);
      } finally {
        this.loading = false;
      }
    },

    mapTrackingRow(r) {
      return {
        trackingId: r.tracking_id || "-",
        agentId: r.agent_id,
        agentName: r.agent_name || "Unknown",
        RegisterNumber: r.user_reg_number || "-",
        agentImage: r.agent_image || "",
        date: r.date || "",
        dayIn: r.day_in || "-",
        dayOut: r.day_out || "-",
        workingTime: r.working_time || "-",

        totalDistance: r.total_distance || 0,
        totalPoints: r.total_points || 0,
        averageSpeed: r.average_speed,
      };
    },

    formatWorkingTime(value) {
      const parts = String(value).split(":");
      if (parts.length !== 3) return value;

      const h = Number(parts[0]) || 0;
      const m = Number(parts[1]) || 0;

      if (h <= 0) return `${m} min`;
      return `${h}h ${m}min`;
    },

    formatWorkingTimeAsDecimal(timeString) {
      if (!timeString || timeString === '-' || timeString === 'N/A') return '-';
      const parts = String(timeString).split(':');
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      
      if (parts.length >= 1) hours = parseInt(parts[0], 10) || 0;
      if (parts.length >= 2) minutes = parseInt(parts[1], 10) || 0;
      if (parts.length >= 3) seconds = parseInt(parts[2], 10) || 0;
      
      const decimalHours = hours + (minutes / 60) + (seconds / 3600);
      
      if (decimalHours === 0) return '0 hrs';
      
      const formatted = Number(decimalHours.toFixed(2));
      return `${formatted} hrs`;
    },

    parseDurationToSeconds(value) {
      if (value === null || value === undefined || value === "") return 0;
      if (typeof value === "number" && isFinite(value)) return Math.max(0, Math.round(value));

      const raw = String(value).trim();
      if (!raw) return 0;
      if (/^\d+$/.test(raw)) return Math.max(0, Number(raw));

      const parts = raw.split(":").map((p) => Number(p));
      if (parts.some((p) => !isFinite(p))) return 0;

      if (parts.length === 3) {
        return Math.max(0, (parts[0] * 3600) + (parts[1] * 60) + parts[2]);
      }

      if (parts.length === 2) {
        return Math.max(0, (parts[0] * 60) + parts[1]);
      }

      return 0;
    },

    formatDurationFromSeconds(totalSec) {
      const sec = Math.max(0, Number(totalSec || 0));
      if (!sec) return "0 min";

      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);

      if (h > 0) return `${h}h ${m}min`;
      if (m > 0) return `${m} min`;
      return "<1 min";
    },

    buildApiTimeDistribution(workingTime, totalWaitingTime) {
      const workingSec = this.parseDurationToSeconds(workingTime);
      const waitingInputSec = this.parseDurationToSeconds(totalWaitingTime);
      const waitingSec = workingSec > 0 ? Math.min(waitingInputSec, workingSec) : waitingInputSec;
      const drivingSec = Math.max(workingSec - waitingSec, 0);
      const totalSec = drivingSec + waitingSec;

      return { drivingSec, waitingSec, totalSec };
    },

    fetchSalesReps() {
      this.salesRepLoading = true;
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      if (!userId) {
        this.salesRepLoading = false;
        return;
      }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/getSalesRepByUserAreaCodes`, {
        params: { userId: parseInt(userId) },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      }).then((response) => {
        if (response.data.success) {
          const list = response.data.data || [];
          this.agentDataOptions = list.map((rep) => ({
            id: rep.id,
            name: rep.salesRep_name || rep.user_name || `${rep.id}`,
            code: rep.userCode || "",
            displayName: rep.salesRep_name || rep.user_name || `${rep.id}`
          }));
        }
      }).catch((error) => {
        console.error("Error fetching sales reps:", error);
      }).finally(() => {
        this.salesRepLoading = false;
      });
    },

    async mapView(item) {
      this.mapViewDialog = true;
      this.resetHistorySnapshot();
      this.disposeCharts();

      // UI Init
      this.agentImage = item.agentImage || "";
      this.agentName = item.agentName || "Loading...";
      this.totalDistanceOverride = item.totalDistance ?? 0;
      this.workingTimeOverride = item.workingTime || "";
      this.totalPointsOverride = Number(item.totalPoints || 0);
      this.averageSpeedOverride = item.averageSpeed ?? 0;
      this.averageWaitingTime = "0 min";

      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");
      const trackingId = item.trackingId;
      
      this.receipts = [];
      this.selectedReceipt = null;

      try {
        const mapDataPromise = axios.get(
            `api/tracking/v1/map-data?trackingId=${trackingId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
        );
        
        const receiptsPromise = axios.get(
            `api/receipts/by-salesrep-date?userId=${userId}&saleRep_id=${item.agentId}&date=${item.date}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
        ).catch(e => {
          console.error("Receipts fetch error:", e);
          return { data: { data: [] } };
        });

        const routeDealersPromise = axios.get('/api/routes/by-date-salesrep', {
          params: { saleRep_id: item.agentId, date: item.date },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }).catch(e => {
          console.error("Route dealers fetch error:", e);
          return { data: { dealers: [] } };
        });

        const [response, receiptRes, routeDealersRes] = await Promise.all([mapDataPromise, receiptsPromise, routeDealersPromise]);

        if (receiptRes && receiptRes.data && receiptRes.data.data) {
          this.receipts = receiptRes.data.data;
        }

        if (routeDealersRes && routeDealersRes.data && routeDealersRes.data.success && Array.isArray(routeDealersRes.data.data)) {
          let allDealers = [];
          const routesDealersList = [];
          routeDealersRes.data.data.forEach(route => {
            if (route.dealers && Array.isArray(route.dealers) && route.dealers.length > 0) {
              route.dealers.forEach(d => {
                d.latitude = d.latitude ?? d.lat ?? d.lattitude ?? d.Latitude;
                d.longitude = d.longitude ?? d.lng ?? d.lon ?? d.long ?? d.Longitude;
              });
              allDealers = allDealers.concat(route.dealers);
              routesDealersList.push({
                dealers: route.dealers,
                routeName: route.route_name || "",
                routeId: route.id,
              });
            }
          });
          this.routeDealers = allDealers;
          this.calculateAndDrawDirections(routesDealersList);
        } else {
          this.routeDealers = [];
          this.dealerRouteGroups = [];
        }

        const payload = response.data || {};
        const summary = payload.summary || {};
        const points = Array.isArray(payload.points) ? payload.points : [];

        this.agentName = summary.agent_name || item.agentName || "";
        this.visitedDate = summary.date || item.date || "";
        this.startTime = summary.day_in || item.dayIn || "";
        this.endTime = summary.day_out || item.dayOut || "";
        this.totalDistanceOverride = summary.total_distance ?? this.totalDistanceOverride;
        this.workingTimeOverride = summary.working_time ?? this.workingTimeOverride;
        this.averageSpeedOverride = summary.average_speed ?? this.averageSpeedOverride;
        this.totalPointsOverride = points.length;

        this.timeDist = this.buildApiTimeDistribution(
            summary.working_time ?? this.workingTimeOverride,
            summary.total_waiting_time
        );
        this.averageWaitingTime = this.formatDurationFromSeconds(this.timeDist.waitingSec);

        this.mapReady = false;
        this.mapRenderKey += 1;

        this.pathCoordinates = points
            .map((p) => ({
              lat: parseFloat(p.lat),
              lng: parseFloat(p.lng),
            }))
            .filter((p) => isFinite(p.lat) && isFinite(p.lng));

        if (this.pathCoordinates.length > 0) {
          this.mapCenter = { ...this.pathCoordinates[0] };
          this.startPoint = this.pathCoordinates[0];
          this.endPoint = this.pathCoordinates[this.pathCoordinates.length - 1];
        } else {
          // If no points, try summary locations
          const dayInLat = parseFloat(summary.day_in_lat);
          const dayInLng = parseFloat(summary.day_in_lng);
          if (isFinite(dayInLat) && isFinite(dayInLng)) {
            this.mapCenter = { lat: dayInLat, lng: dayInLng };
            this.startPoint = { lat: dayInLat, lng: dayInLng };
          }
          const dayOutLat = parseFloat(summary.day_out_lat);
          const dayOutLng = parseFloat(summary.day_out_lng);
          if (isFinite(dayOutLat) && isFinite(dayOutLng)) {
            this.endPoint = { lat: dayOutLat, lng: dayOutLng };
          }
        }

        // Generate snapshot or fallback to interactive map
        if (this.validReceipts.length > 0 || this.routeDealers.length > 0) {
          this.historySnapshotUrl = null; // Force interactive map for popups
        } else {
          this.historySnapshotUrl = this.buildStaticMapUrl(this.pathCoordinates);
        }

        // Start spinner - it will be cleared by onSnapshotLoaded (if staticUrl) or onMapIdle (if fallback)
        this.isSnapshotLoading = true;

        // Safety timeout to prevent stuck loader
        setTimeout(() => {
          if (this.isSnapshotLoading) {
            console.warn("Map loading timed out - forcing clearance");
            this.isSnapshotLoading = false;
          }
        }, 10000);

        await this.$nextTick();
        if (!this.mapViewDialog) return;
        this.mountTimeDonut();
      } catch (e) {
        console.error("Map data error:", e);
        this.isSnapshotLoading = false; // Ensure cleared on error
      }
    },

    async selectDealer(dealer) {
      if (!dealer) return;
      const sameDealer = this.selectedDealer && this.selectedDealer.id === dealer.id;
      this.selectedDealer = null;
      if (sameDealer) {
        await this.$nextTick();
      }
      this.selectedDealer = dealer;
      this.selectedDealerKey += 1;
    },

    closeDealerCard() {
      this.selectedDealer = null;
    },

    async calculateAndDrawDirections(routesDealersList) {
      this.dealerRouteGroups = [];

      if (!routesDealersList || routesDealersList.length === 0) {
        return;
      }

      const colors = ["#2A8200", "#7C3AED", "#2563EB", "#502525", "#0F766E", "#D97706", "#9333EA", "#EA580C", "#0891B2", "#BE185D", "#65A30D", "#B45309"];
      const routeGroups = [];
      const colorByRouteId = {};
      const getRouteKey = (routeItem, index) => {
        const rawId = routeItem?.routeId ?? routeItem?.route_id;
        if (rawId === undefined || rawId === null || rawId === "") return `route-unknown-${index}`;
        return String(rawId);
      };
      const upsertGroup = (routeKey, routeItem) => {
        let group = routeGroups.find((g) => g.routeId === routeKey);
        if (!group) {
          const color = colorByRouteId[routeKey] || pickNextColor();
          colorByRouteId[routeKey] = color;
          group = {
            routeId: routeKey,
            routeName: routeItem?.routeName || "",
            color,
            segments: [],
          };
          routeGroups.push(group);
        }
        return group;
      };
      const directionsService = new window.google.maps.DirectionsService();
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));
      const requestRoutePath = async (request, maxRetries = 6) => {
        let attempt = 0;
        let backoffMs = 1000;

        while (attempt < maxRetries) {
          const { result, status } = await new Promise((resolve) => {
            try {
              directionsService.route(request, (result, status) => resolve({ result, status }));
            } catch (err) {
              resolve({ result: null, status: "EXCEPTION" });
            }
          });

          if (status === window.google.maps.DirectionsStatus.OK && result?.routes?.[0]?.overview_path) {
            return result.routes[0].overview_path.map((p) => ({
              lat: typeof p.lat === "function" ? p.lat() : p.lat,
              lng: typeof p.lng === "function" ? p.lng() : p.lng,
            }));
          }

          if (status === window.google.maps.DirectionsStatus.OVER_QUERY_LIMIT || status === window.google.maps.DirectionsStatus.UNKNOWN_ERROR) {
            await delay(backoffMs);
            backoffMs *= 2;
            attempt += 1;
            continue;
          }

          console.warn("Directions request failed due to " + status);
          return null;
        }

        console.warn("Directions request failed after retries.");
        return null;
      };

      // usedColorSet tracks assigned colors; reset when all colors are exhausted
      const usedColorSet = new Set();
      const pickNextColor = () => {
        if (usedColorSet.size >= colors.length) usedColorSet.clear();
        for (let c = 0; c < colors.length; c++) {
          if (!usedColorSet.has(colors[c])) {
            usedColorSet.add(colors[c]);
            return colors[c];
          }
        }
        return colors[0];
      };

      for (let index = 0; index < routesDealersList.length; index++) {
        const routeItem = routesDealersList[index];
        const dealers = routeItem?.dealers;
        const cleanDealers = Array.isArray(dealers)
          ? dealers.filter(d => Number.isFinite(Number(d.latitude)) && Number.isFinite(Number(d.longitude)))
          : [];
        if (cleanDealers.length < 2) continue;

        const routeKey = getRouteKey(routeItem, index);
        const group = upsertGroup(routeKey, routeItem);

        const segmentRequests = [];
        for (let i = 0; i < cleanDealers.length - 1; i += 1) {
          const originDealer = cleanDealers[i];
          const destDealer = cleanDealers[i + 1];

          const origin = { lat: Number(originDealer.latitude), lng: Number(originDealer.longitude) };
          const destination = { lat: Number(destDealer.latitude), lng: Number(destDealer.longitude) };

          const request = {
            origin,
            destination,
            travelMode: window.google.maps.TravelMode.DRIVING
          };

          segmentRequests.push(requestRoutePath(request));
        }

        const segments = await Promise.all(segmentRequests);
        segments.forEach((path) => {
          if (path && path.length > 0) {
            group.segments.push(path);
          }
        });

        this.dealerRouteGroups = [...routeGroups];
      }
    },

    disposeCharts() {
      const donut = this.timeDonutChartInstance;
      this.timeDonutChartInstance = null;

      try {
        if (donut) donut.dispose();
      } catch (e) {
        console.warn("Chart dispose warning:", e);
      }

      try {
        am4core.disposeAllCharts();
      } catch (e) {
        console.warn("am4core disposeAllCharts warning:", e);
      }
    },

    mountTimeDonut() {
      if (!this.mapViewDialog) return;
      if (!this.$refs.timeDonutDiv) return;
      if (!this.timeDist || this.timeDist.totalSec === 0) return;

      if (this.timeDonutChartInstance) {
        this.timeDonutChartInstance.dispose();
        this.timeDonutChartInstance = null;
      }

      const chart = am4core.create(this.$refs.timeDonutDiv, am4charts.PieChart);
      chart.logo.disabled = true;
      chart.innerRadius = am4core.percent(65);

      chart.data = [
        { category: "Driving", value: Math.max(0, Math.round(this.timeDist.drivingSec / 60)) },
        { category: "Waiting", value: Math.max(0, Math.round(this.timeDist.waitingSec / 60)) },
      ];

      const pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "category";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      pieSeries.colors.list = [
        am4core.color("#7C3AED"),
        am4core.color("#2563EB"),
      ];

      pieSeries.slices.template.stroke = am4core.color("#ffffff");
      pieSeries.slices.template.strokeWidth = 2;

      this.timeDonutChartInstance = chart;
    },

    exportPDF() {
      const doc = new jsPDF();
      doc.text("OverRoll Tracking report", 14, 10);

      const tableData = this.filteredData.map((item, idx) => [
        idx + 1,
        item.trackingId,
        item.agentName,
        item.date,
        this.formatTimeOnly(item.dayIn),
        this.formatTimeOnly(item.dayOut),
        item.totalDistance,
        item.workingTime,
      ]);

      doc.autoTable({
        head: [["No.", "TRACKING ID", "SALES REP NAME","DATE", "DAY IN", "DAY OUT","TOTAL DISTANCE", "WORKING HOURS"]],
        body: tableData,
        headStyles: { fillColor: [128, 0, 128] },
      });

      doc.save("Overall tracking History.pdf");
    },

    exportExcel() {
      const tableData = this.filteredData.map((item, idx) => ({
        "NO": idx + 1,
        "TRACKING ID": item.trackingId,
        "SALES REP NAME": item.agentName,
        "DATE": item.date,
        "DAY IN": this.formatTimeOnly(item.dayIn),
        "DAY OUT": this.formatTimeOnly(item.dayOut),
        "TOTAL DISTANCE": item.totalDistance,
        "WORKING HOURS": item.workingTime,
      }));

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Overall Tracking history");
      XLSX.writeFile(workbook, "Overall Tracking history.xlsx");
    },

    downloadPdf() {
      this.showDownloadButton = false;
      this.$nextTick(() => {
        const mapElement = this.$refs.mapElement?.$el || this.$refs.mapElement;
        if (!(mapElement instanceof HTMLElement)) {
          this.showDownloadButton = true;
          return;
        }

        html2canvas(mapElement, { useCORS: true, logging: false, scale: 2 })
            .then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF({
                orientation: "landscape",
                unit: "pt",
                format: [canvas.width, canvas.height],
              });
              pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
              pdf.save("overRollTracking.pdf");
              this.showDownloadButton = true;
            })
            .catch((e) => {
              console.error("PDF capture error:", e);
              this.showDownloadButton = true;
            });
      });
    },

    confirmDelete(item) {
      this.deleteAgentId = item.agentId || "";
      this.deleteTrackingId = item.trackingId || "";
      this.deleteDate = item.date;
      this.deleteDialog = true;
    },

    deleteItem() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
          .delete('api/tracking/v1/destroy', {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            data: {
              userId: parseInt(userId),
              trackingId: this.deleteTrackingId,
              agentId: this.deleteAgentId
            }
          })
          .then(() => {
            this.deleteDialog = false;
            this.getAllTracking(this.page);
            this.showSnackbar("The tracking record was successfully deleted.", "success");
          })
          .catch((error) => {
            console.error("Delete error:", error);
          });
    },
    

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

  },
};
</script>

<style lang="scss" scoped>
@use "../../styles/tracking_management/overall_tracking_history.scss" as *;

    .sales-rep-name-text {
      color: #333;
    }

    .sales-rep-code-text {
      color: #156CF7;
      font-weight: 600;
      margin-left: 6px;
    }

    .custom_page_color_view {
      color: #156CF7 !important;
      font-weight: bold;
    }

    .custom_page_color_delete {
      color: #BB0000 !important;
      font-weight: bold;
    }

</style>

